// extracted by mini-css-extract-plugin
export default {"form":"MoveDialogForm-module__form--gHVpu","autoComplete":"MoveDialogForm-module__autoComplete--jWPlJ","datePickerAnchor":"MoveDialogForm-module__datePickerAnchor--cpNRJ"};